<template>
  <modal-layout
    id="orderRefuse-layer"
    add-class="type-b layer_section_renew layer_section_prd"
  >
    <popup-unavailable-products
      :purchase-type="purchaseType"
      :cur-seq="curSeq"
      :re-orderble="reOrderble"
      :re-cal-dose-info="reCalDoseInfo"
      :soldout-products="soldoutProducts"
      @remove-and-proceed="$emit('remove-and-proceed')"
      @cancel-pack="$emit('cancel-pack')"
      @dispose="onDispose"
    />
  </modal-layout>
</template>
<script>
import ModalLayout from "@/components/global/ModalLayout.vue";
import modalMixin from "@/components/global/modal-mixin";
import PopupUnavailableProducts from "@/components/modal-popups/PopupUnavailableProducts.vue";
export default {
  name: "ModalUnavailableProducts",
  props: {
    purchaseType: {
      type: String,
      default: "",
    },
    curSeq: {
      type: Number,
      default: 0,
    },
    reOrderble: {
      type: Boolean,
      default: true,
    },
    reCalDoseInfo: {
      type: Array,
      default: () => [],
    },
    soldoutProducts: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ModalLayout,
    PopupUnavailableProducts,
  },
  mixins: [modalMixin],
};
</script>